import ExpandMoreIcon from 'site-theme/icons/_ExpandMore';
import MatchedMap from 'utilities/src/matchedMap';
import { FlyoutBGEnum } from '../types/_bg';
import { type FlyoutThemeProps } from '../types/_theme';

import { FlyoutType } from '../_props';

const flyoutSubUlContainer =
  'absolute mt-[76px] invisible opacity-0 inset-y-2/4 transform duration-300 group-hover:-inset-y-0 group-hover:visible group-hover:opacity-100';

const flyoutSelectedClasses = 'border-t-4 px-4';
const flyoutSelectedBGClasses = new MatchedMap([
  [FlyoutBGEnum.Light, 'border-t-site-neutrals-0'],
  [FlyoutBGEnum.Dark, 'hover:border-t-site-primary-600'],
]);

const flyoutLiClasses = 'flex h-full hover:text-site-primary-600';
const flyoutLiBGClasses = new MatchedMap([
  [FlyoutBGEnum.Light, 'text-site-neutrals-800'],
  [FlyoutBGEnum.Dark, 'text-site-neutrals-0'],
]);

const flyoutSelectedNotActiveClasses = new MatchedMap([
  [FlyoutBGEnum.Light, 'border-t-site-neutrals-0'],
  [FlyoutBGEnum.Dark, 'border-t-site-neutrals-800'],
]);

const flyoutSelectedActiveClasses = new MatchedMap([
  [FlyoutBGEnum.Light, ''],
  [FlyoutBGEnum.Dark, 'border-t-site-primary-600'],
]);

const flyoutArrowGlyphClass = new MatchedMap([
  [FlyoutBGEnum.Light, 'fill-site-neutrals-800'],
  [FlyoutBGEnum.Dark, 'fill-site-neutrals-0'],
]);

const flyoutLiSize = '';
const flyoutSubUlThemeClasses = 'bg-site-neutrals-0 drop-shadow-lg';
const flyoutSubLiThemeClasses = 'font-normal hover:bg-site-neutrals-25';
const flyoutSubLiCenter = 'justify-center';
const flyoutSubLiEnd = 'justify-end';
const flyoutSubLinkThemeClasses = 'text-xs xl:text-sm';

const flyoutIconProps = ({ bg = 'Light' }: FlyoutThemeProps): FlyoutType['iconProps'] => ({
  bg: false,
  size: 'IconS',
  options: {
    className: flyoutArrowGlyphClass.get(FlyoutBGEnum[bg]),
  },
});

const flyoutSiteTheme = ({ bg = 'Light' }: FlyoutThemeProps) => ({
  flyoutSubUlContainer,
  flyoutSelectedClasses: flyoutSelectedClasses.concat(' ', flyoutSelectedBGClasses.get(FlyoutBGEnum[bg])),
  flyoutLiClasses: flyoutLiClasses.concat(' ', flyoutLiBGClasses.get(FlyoutBGEnum[bg])),
  flyoutSelectedActiveClasses: flyoutSelectedActiveClasses.get(FlyoutBGEnum[bg]),
  flyoutSelectedNotActiveClasses: flyoutSelectedNotActiveClasses.get(FlyoutBGEnum[bg]),
  flyoutArrowGlyphClass: flyoutArrowGlyphClass.get(FlyoutBGEnum[bg]),
  flyoutLiSize,
  flyoutSubUlThemeClasses,
  flyoutSubLiThemeClasses,
  flyoutIconProps: flyoutIconProps({ bg }),
  flyoutSubLiCenter,
  flyoutSubLiEnd,
  ExpandMoreIcon,
  flyoutSubLinkThemeClasses,
});

export default flyoutSiteTheme;
